import React from "react";

const styles = {
	container: {
		fontSize: "0.9em",
		marginBottom: 5,
	},
	label: {
		fontWeight: 600,
		marginRight: "5px",
	},
};

const AnalysisDetailsField = ({ label, field }) => {
	return (
		<div style={styles.container}>
			<span style={styles.label}>{label} </span> :
			<span style={{ marginLeft: "5px" }}>
				{typeof field !== "boolean" && field.includes("\n") ? (
					<div style={{ paddingLeft: "20px" }}>{field.split(/(?:\r\n|\r|\n)/g).reduce((prev, curr) => [prev, <br />, curr])}</div>
				) : (
					field
				)}
				{typeof field === "boolean" ? (field === true ? "Oui" : "Non") : ""}
			</span>
		</div>
	);
};

export default AnalysisDetailsField;
